import { Checkbox } from "primereact/checkbox";

interface TourToggleMenuItemProps {
  isTourVisible: boolean;
  toggleTourVisibility: () => void;
}

export function TourToggleMenuItem({
  isTourVisible,
  toggleTourVisibility,
}: TourToggleMenuItemProps) {
  return (
    <div style={{ padding: "0.75rem 1rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <Checkbox inputId="tour-toggle" checked={isTourVisible} onChange={toggleTourVisibility} />
        <label htmlFor="tour-toggle" style={{ cursor: "pointer", fontSize: "0.875rem" }}>
          Show Tour
        </label>
      </div>
    </div>
  );
}
